import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import {HeaderProvider} from './components/header/header-provider';
import {AngularMaterialModule} from '../app-module/angular-matrial.module';
import { FilterPipe } from './custom_pipe/shared/filter.pipe';
import {SidebarProvider} from './components/sidebar/sidebar-provider';
//import { ImageUploadModule } from "angular2-image-upload";
@NgModule({
    imports: [
        CommonModule,
        LayoutRoutingModule,
        TranslateModule,
        AngularMaterialModule,
        NgbDropdownModule.forRoot(),
//        buttonModule.forRoot(),
 
    ],
    declarations: [LayoutComponent, SidebarComponent, HeaderComponent, FilterPipe],
    providers: [HeaderProvider, SidebarProvider]
})
export class LayoutModule {}
